import React from "react";
import {
  Box,
  Typography,
  Button,
  FormControlLabel,
  TextField,
} from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import axios from "axios";

class EmailTemplateFragment extends React.Component {
  state = {
    isEditing: false,
    data: {
      id: "",
      template_name: "",
      mail_text: "",
      slug: "",
      mail_subject: "",
    },
  };

  editData = () => {
    if (
      this.props.permissions &&
      this.props.permissions.indexOf("email-template-edit") > 0
    ) {
      this.setState({
        data: {
          id: this.props.fragmentsData.id,
          mail_subject: this.props.fragmentsData.mail_subject,
          mail_text: this.props.fragmentsData.mail_text,
          slug: this.props.fragmentsData.slug,
          template_name: this.props.fragmentsData.template_name,
        },
        isEditing: true,
      });
    } else {
      this.setState({
        data: {
          id: this.props.fragmentsData.id,
          mail_subject: this.props.fragmentsData.mail_subject,
          mail_text: this.props.fragmentsData.mail_text,
          slug: this.props.fragmentsData.slug,
          template_name: this.props.fragmentsData.template_name,
        },
        isEditing: true,
      });
    }
  };

  submitForm = () => {
    this.props.authCheckState();
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .put(
        window.location.origin +
          `/api/v1/email_template/` +
          this.state.data.id +
          "/",
        {
          template_name: this.state.data.template_name,
          mail_subject: this.state.data.mail_subject,
          mail_text: this.state.data.mail_text,
          slug: this.state.data.slug,
        }
      )
      .then((resp) => {
        if (typeof resp.data === "object") {
          this.props.loadData();
          this.setState({
            isEditing: false,
          });
        }
      })
      .catch((err) => {
        this.setState({
          isErrorDialogPopUp: true,
          ErrorMessage: "Failed to load trainings",
        });
      });
  };

  componentDidMount() {
    this.setState({
      isEditing: false,
    });
  }

  render() {
    return this.state.isEditing ? (
      <Box width="xl" style={{ backgroundColor: "#fff", minHeight: "400px" }}>
        <Typography variant="h4" align="left">
          {this.props.currentFragment}
        </Typography>
        <br />
        <Typography variant="h5" align="left">
          Subject
        </Typography>
        <div>
          <FormControlLabel
            style={{ width: "40%" }}
            control={
              <TextField
                type="text"
                value={this.state.data.mail_subject}
                style={{ width: "100%" }}
                onChange={(e) => {
                  let data = this.state.data;
                  data["mail_subject"] = e.target.value;
                  this.setState({ data: data });
                }}
                label="Email Subject"
              ></TextField>
            }
          />
        </div>

        <br />
        <br />
        <Typography variant="h6" align="left">
          Body
        </Typography>
        <div>
          <FormControlLabel
            label=""
            style={{ width: "40%", justifyContent: "flex-start" }}
            control={
              <TextareaAutosize
                type="text"
                value={this.state.data.mail_text}
                style={{ width: "100%" }}
                onChange={(e) => {
                  let data = this.state.data;
                  data["mail_text"] = e.target.value;
                  this.setState({ data: data });
                }}
                label="Email Text"
                aria-label="minimum height"
                rowsMin={3}
                placeholder="Message"
              />
            }
          />
        </div>
        <Button variant="text" onClick={this.submitForm}>
          Save
        </Button>
      </Box>
    ) : (
      <Box width="xl" style={{ backgroundColor: "#fff", minHeight: "400px" }}>
        <Typography variant="h4" align="left">
          {this.props.currentFragment}
          <Button variant="text" onClick={this.editData}>
            <Edit />
          </Button>
        </Typography>
        <br />
        <Typography variant="h5" align="left">
          Subject
        </Typography>
        <Typography variant="body1" align="left">
          {this.props.fragmentsData.mail_subject}
        </Typography>
        <br />
        <br />
        <Typography variant="h6" align="left">
          Body
        </Typography>
        <Typography variant="body1" align="left">
          {this.props.fragmentsData.mail_text}
        </Typography>
      </Box>
    );
  }
}
export default EmailTemplateFragment;
